import React, { useLayoutEffect, useState, useEffect } from "react";
import Slider from "../components/slider";
import ShopingCer from "../components/shopingCer";
import SpecialProducts from "../components/specialProducts";
import ProductSection from "../components/product/productSections";
import {
  CommingSoonProduct,
  davatFreinds,
  getProducts,
  specialProduct,
  topProduct,
  productPackage,
} from "../axios";
import CommingSoon from "../components/product/commingSoon";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import ParticlesBackground from "../components/ParticlesBackground";
import ProductPackages from "../components/productPackages";
import StatisticCounter from "../components/statistic-counter/StatisticCounter";
import BlogNews from "../components/common/BlogNews";
import inviteFriendsImg from "../assets/img/bg/inviteFriends.jpg";
import AtroFastSection from "../components/AtroFastSection";
import StudioAtropineSlider from "../components/StudioAtropineSlider";

const Home = () => {
  const [productPackages, setProductPackages] = useState([]);
  const [products, setProducts] = useState([]);
  const [specialProducts, setSepcialProducts] = useState([]);
  const [topProducts, setTopProducts] = useState([]);
  const [atroFastProducts, setAtroFastProducts] = useState([]);
  // const [commintSoonPrduct, setCommintSoonPrduct] = useState([]);
  const [phone, setPhone] = useState("");

  const davatHandler = (e) => {
    e.preventDefault();
    if (phone === "") {
      toast.error("لطفا شماره خود را وارد نمایید.");
    } else {
      davatFreinds(+phone)
        .then(({ data }) => {
          setPhone("");
          if (data === "1") {
            toast.success("شماره با موفقیت ثبت شد");
          } else {
            toast.error("شماره درست نمیباشد");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  useLayoutEffect(() => {
    const removeFileAsli = (items) =>
      items.map(({ fileasli, ...rest }) => rest);

    getProducts().then(({ data }) => {
      setProducts(removeFileAsli(data));
      const atro = data.filter((item) => item.id !== 4 && item.isAsli);
      const atro2 = atro.filter((item) => item.isAtroFast);
      setAtroFastProducts(removeFileAsli(atro2));
    });

    specialProduct().then(({ data }) => {
      setSepcialProducts(removeFileAsli(data));
    });

    productPackage().then(({ data }) => {
      setProductPackages(removeFileAsli(data));
    });

    topProduct().then(({ data }) => {
      setTopProducts(removeFileAsli(data));
    });

    // CommingSoonProduct().then(({ data }) => {
    //   setCommintSoonPrduct(removeFileAsli(data));
    // });
  }, []);

  // console.log("data1", products);
  // console.log("specialProduct", specialProducts);
  // console.log("productPackages", productPackages);
  // console.log("topProducts", topProducts);

  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    const scrollToTop = () => {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 0); // Ensure this executes after DOM updates
    };

    scrollToTop();
  }, [pathname]);

  return (
    <React.Fragment>
      <ParticlesBackground />

      <Slider />

      <ProductSection
        title={"تدریس های پیشنهادی مؤسسه آتروپین"}
        listProducts={topProducts}
      />

      <AtroFastSection data={atroFastProducts} />

      <section className="home-video-container">
        <div class="h_iframe-aparat_embed_frame iframe-container">
          <span style={{ display: "block", paddingTop: "57%" }}></span>
          <iframe
            src="https://www.aparat.com/video/video/embed/videohash/gmbuh4r/vt/frame"
            allowFullScreen="true"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
          ></iframe>
        </div>
      </section>

      <ProductPackages data={productPackages} />

      <section className="home-video-container">
        <div class="h_iframe-aparat_embed_frame iframe-container">
          <span style={{ display: "block", paddingTop: "57%" }}></span>
          <iframe
            src="https://www.aparat.com/video/video/embed/videohash/xrareue/vt/frame"
            allowFullScreen="true"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
          ></iframe>
        </div>
      </section>

      <SpecialProducts data={specialProducts} />

      {/* <CommingSoon products={commintSoonPrduct} /> */}
      {/* <div
        className="invite-friends-container container"
        
      >
        <span
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            borderRadius: "0 8px 0 8px",
          }}
          className="bg-white p-2 shadow-sm"
        >
          دعوت از دوستان
        </span>
        <img src={inviteFriendsImg} alt="Invite Friends"/>
        <div className="invite-form-container d-flex align-items-center justify-content-center flex-column w-100 h-100 mx-auto ">
        <p className="color-secondary" style={{ margin: "8px auto" }}>
            شماره تماس موبایل{" "}
          </p>
          <input
            name="phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className=""
            type="number"
            placeholder="*******0912"
          />
          <button
            onClick={davatHandler}
            className="invite_btn"
          >
            دعوت کن بیاد
          </button>
        </div>
      </div> */}

      <StudioAtropineSlider/>

      <BlogNews />
      <StatisticCounter />
    </React.Fragment>
  );
};

export default Home;

// ------------------------------------- کامپوننت هایی که قبلا نوشته شده بودن برای نمایش داده شدن در صفحه اولّ
//  {/* <ShopingCer /> */}
//  {/* <Banner /> */}
//  {/* <ProductSection title={"محصولات"} listProducts={products} /> */}
//  {/* <TopCategory /> */}
//  {/* <BlogSections /> */}
//  {/* <OurCustomers /> */}
